
jQuery( document ).ready(function() {

    if ( $('.videothequepage_filter').length ) {

        $('#categoryVideos').on('change', function (e) {
            e.preventDefault();
            var id_taxanomy = $(this).val();
            var child_select = 0;
            getVideos(id_taxanomy, child_select);
        });

        $(document).on('change', '#videosByDate', function(e) {
            e.preventDefault();
            var id_taxanomy = $(this).val();
            var child_select = 1;
            getVideos(id_taxanomy, child_select);
        });

        function getVideos(id_taxanomy, child_select) {
            
            if (child_select != 1) {
                $(".videothequepage_childselect").html("");
            }

            $(".videothequepage_videos").html("");
            $('body').append( "<div class='loader'></div>" );
            $('.div_modal_light').addClass( "visible" );
            
            $.ajax({
                type: 'POST',
                url: ajax_auth_object.ajaxurl,
                dateType: 'JSON', 
                data: {
                action: "fetch_videos",
                id_taxanomy:id_taxanomy, 
                },
                success: function(data) {
                    var success = $.parseJSON(data);
                    if (child_select != 1) {
                        $(".videothequepage_childselect").append(success.child_select);
                    }
                    
                    $(".videothequepage_videos").append(success.content);
                    $('.loader').remove();
                    $('.div_modal_light').removeClass( "visible" );
                }
            });
        } 
    }
});


window.fetchVimeoThumbnail = function(loopIndex, videoCode) {
    fetch('http://vimeo.com/api/oembed.json?url=https://vimeo.com/' + videoCode)
        .then(response => response.json())
        .then(data => {
            const thumbnailUrl = data.thumbnail_url;
            const thumbnailContainer = document.getElementById('thumbnailContainer_' + loopIndex + "_" + videoCode);
            if (thumbnailContainer) {
                thumbnailContainer.style.backgroundImage = 'url(' + thumbnailUrl + ')';
            }
        })
        .catch(error => console.error('Error fetching Vimeo thumbnail:', error));
};

/*
function fetchVimeoThumbnail(loopIndex, videoCode) {
    fetch('http://vimeo.com/api/oembed.json?url=https://vimeo.com/' + videoCode)
        .then(response => response.json())
        .then(data => {
            const thumbnailUrl = data.thumbnail_url;
            const thumbnailContainer = document.getElementById('thumbnailContainer_' + loopIndex + "_" + videoCode);
            if (thumbnailContainer) {
                thumbnailContainer.style.backgroundImage = 'url(' + thumbnailUrl + ')';
            }
        })
        .catch(error => console.error('Error fetching Vimeo thumbnail:', error));
};

document.addEventListener('DOMContentLoaded', function () {
    const videoElements = document.querySelectorAll('.videothequepage_videos_list_img');
    videoElements.forEach(function (videoElement) {
        const loopIndex = videoElement.getAttribute('data-loop-index');
        const videoCode = videoElement.getAttribute('data-video-code');
        if (loopIndex !== null && videoCode !== null && loopIndex !== '' && videoCode !== '') {
            console.log(loopIndex, videoCode)
            fetchVimeoThumbnail(loopIndex, videoCode);
        }
    });
});
 */